export default __webpack_public_path__ + "static/media/cura.4c1c3152.svg";